/* eslint-disable default-case */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, Card, CardContent, Dialog, DialogTitle, DialogContent, TextField, DialogActions, AppBar, Toolbar, Alert, IconButton, Tabs, Tab, CircularProgress, TableCell, TableRow, TableHead, TableContainer, TableBody, Paper, Table, FormControl, InputLabel, Select, MenuItem, Menu, Grid } from '@mui/material';
import axiosInstance from '../../helper/AxiosInstance';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { jsPDF } from 'jspdf';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import CertificateGenerator from "./CertificateGenerator";
import ScheduleIcon from '@mui/icons-material/Schedule';
// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const SuperAdmin = () => {
  const [openAdminDialog, setOpenAdminDialog] = useState(false);
  const [adminData, setAdminData] = useState({
    userEmail: '',
    userPassword: '',
    userName: '',
    userRole: 'admin',
    userTrack: '',
  });
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showAdminPassword, setShowAdminPassword] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState({ admins: false, });
  const [admins, setAdmins] = useState([]);
  const [judges, setJudges] = useState([]);

  const handleChange = (e) => {
    setAdminData({ ...adminData, [e.target.name]: e.target.value });
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleAddAdmin = async () => {
    try {
      setLoading(prev => ({ ...prev, submission: true }));
      setError('');
      setSuccess('');

      const response = await axiosInstance.post('/scoring/adduser', adminData);

      if (response.data.status) {
        setSuccess('Admin added successfully!');
        fetchAdmins();
        setAdminData({
          userEmail: '',
          userPassword: '',
          userName: '',
          userRole: 'admin',
          userTrack: '',
        });
        setTimeout(() => setOpenAdminDialog(false), 1500);
      } else {
        setError(response.data.statusMessage || 'Failed to add admin');
      }
    } catch (error) {
      setError('Error adding admin');
    } finally {
      setLoading(prev => ({ ...prev, submission: false }));
    }
  };

  const handleAdminDialogClose = () => {
    setAdminData({
      userEmail: '',
      userPassword: '',
      userName: '',
      userRole: 'admin',
      userTrack: '',
    });
    setOpenAdminDialog(false);
    setError('');
    setSuccess('');
  }

  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);

  const handleLogoutConfirm = () => {
    sessionStorage.removeItem('userData');
    navigate('/login');
  };

  useEffect(() => {
    fetchAdmins();
    fetchJudges();
  }, []);

  const fetchAdmins = async () => {
    try {
      setLoading(prev => ({ ...prev, admins: true }));
      const response = await axiosInstance.get('/scoring/fetchalluser');

      if (response.data?.userList) {
        const adminList = response.data.userList.filter(
          user => user.userRole?.toLowerCase() === 'admin'
        );
        setAdmins(adminList);
      }
    } catch (err) {
      console.error("Error fetching admins", err);
      setError('Failed to fetch admins');
    } finally {
      setLoading(prev => ({ ...prev, admins: false }));
    }
  };

  const fetchJudges = async () => {
    try {
      setLoading(prev => ({ ...prev, judges: true }));
      const response = await axiosInstance.get('/scoring/fetchalluser');
      if (response.data?.userList) {
        const trackJudges = response.data.userList.filter(
          user => user.userRole.startsWith('j')
        );
        setJudges(trackJudges);
      }
    } catch (err) {
      setError('Failed to fetch judges');
    } finally {
      setLoading(prev => ({ ...prev, judges: false }));
    }
  };

  const [top3List, setTop3List] = useState([]);

  const [selectedTrack, setSelectedTrack] = useState(1);

  useEffect(() => {
    if (activeTab === 2) {
      fetchTop3(selectedTrack);
    }
  }, [activeTab, selectedTrack]);

  const fetchTop3 = async (track) => {
    try {
      const res = await axiosInstance.get(`/scoring/fetchtop3prasentationbyscore?track=${track}`);
      if (res.data?.userList) {
        setTop3List(res.data.userList);
      }
    } catch (error) {
      console.error("Error fetching top 3:", error);
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedAdmin, setSelectedAdmin] = useState("");

  const handleMenuOpen = (event, judge) => {
    setAnchorEl(event.currentTarget);
    setSelectedAdmin(judge);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedAdmin("");
  };

  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const handleDeleteAdmin = async () => {
    setOpenDeleteDialog(false);
    if (!selectedAdmin) return;
    try {
      setLoading((prev) => ({ ...prev, submission: true }));
      await axiosInstance.delete("/scoring/deleteuserbyid", {
        params: { id: selectedAdmin.id },
      });

      setAdmins((prev) => prev.filter((j) => j.id !== selectedAdmin.id));
    } catch (err) {
      console.error("Error deleting admin:", err);
      setError("Failed to delete admin.");
    } finally {
      setLoading((prev) => ({ ...prev, submission: false }));
      handleMenuClose();
    }
  };

  const [generating, setGenerating] = useState(false);

  const getBackgroundImage = (rank) => {
    switch (rank) {
      case 1: return "/winner-certificate.jpg"; // Winner background
      case 2: return "/first-runnerup-certificate.jpg"; // 1st runner-up background
      case 3: return "/second-runnerup-certificate.jpg"; // 2nd runner-up background
    }
  };

  // Positioning constants (adjust these values as needed)
  const NAME_FONT_SIZE = 60;   // px
  const TITLE_FONT_SIZE = 50;  // px
  const NAME_Y = 510;          // px from top
  const TITLE_Y = 635;         // px from top

  const generateCertificate = async (item) => {
    setGenerating(true);

    try {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = getBackgroundImage(item.rank);

      await new Promise((resolve, reject) => {
        img.onload = resolve;
        img.onerror = reject;
        setTimeout(() => {
          if (!img.complete) reject(new Error("Image loading timed out"));
        }, 5000);
      });

      const pdf = new jsPDF({
        orientation: 'landscape',
        unit: 'px',
        format: [img.width, img.height]
      });

      pdf.addImage(img, 'JPEG', 0, 0, img.width, img.height);

      // Name + Organization
      pdf.setFontSize(NAME_FONT_SIZE);
      pdf.setFont("times", "bold");
      pdf.setTextColor(223, 250, 60);

      const nameWithOrg = `${item.presentation.authorName}, ${item.presentation.organization || "Organization Name"}`;
      const nameWidth = pdf.getTextWidth(nameWithOrg);
      const nameX = (img.width - nameWidth) / 2;
      pdf.text(nameWithOrg, nameX, NAME_Y);

      // Title
      pdf.setFontSize(TITLE_FONT_SIZE);
      pdf.setFont("times", "bold");
      // pdf.setTextColor(136, 194, 106);
      pdf.setTextColor(255, 255, 255);

      const title = item.presentation.title;
      const TITLE_MAX_WIDTH = 2000;
      const TITLE_LINE_HEIGHT = 70;
      const lines = pdf.splitTextToSize(title, TITLE_MAX_WIDTH);

      const titleHeight = lines.length * TITLE_LINE_HEIGHT;
      const titleStartY = TITLE_Y - (titleHeight / 2) + (TITLE_LINE_HEIGHT / 2);

      lines.forEach((line, index) => {
        const lineWidth = pdf.getTextWidth(line);
        const lineX = (img.width - lineWidth) / 2;
        pdf.text(line, lineX, titleStartY + (index * TITLE_LINE_HEIGHT));
      });

      // Track name
      pdf.setFontSize(30);
      pdf.setTextColor(200, 200, 200);
      const trackName = getTrackName(selectedTrack);
      const trackWidth = pdf.getTextWidth(trackName);
      const trackX = (img.width - trackWidth) / 2;
      pdf.text(trackName, trackX, img.height - 100);

      pdf.save(`${getTrackName(selectedTrack).replace(/\s+/g, '_')}_${item.presentation.authorName.replace(/\s+/g, '_')}.pdf`);

    } catch (error) {
      console.error("Error generating certificate:", error);
    } finally {
      setGenerating(false);
    }
  };

  const getRankText = (rank) => {
    switch (rank) {
      case 1: return '1st';
      case 2: return '2nd';
      case 3: return '3rd';
      default: return `${rank}th`;
    }
  };

  const getTrackName = (trackNumber) => {
    const trackNames = {
      1: "Structures & Materials 1",
      2: "Structures & Materials 2",
      3: "Vehicle Dynamics",
      4: "System Dynamics & Machinery",
      5: "Fluids & Co-Simulation",
      6: "Virtual Manufacturing"
    };
    return trackNames[trackNumber] || `Track ${trackNumber}`;
  };

  const prepareChartData = (presentation) => {
    const categories = [
      'Business Context',
      'Complexity',
      'Interpretation',
      'Business Value',
      'Presentation Quality'
    ];

    const judge1Data = [
      parseInt(presentation.j1BusinessAndEngineeringContext || 0),
      parseInt(presentation.j1ComplexityOfTechnicalSolutions || 0),
      parseInt(presentation.j1InterpretationOfResultsAndConclusion || 0),
      parseInt(presentation.j1BusinessValueDiscussionAndAchievement || 0),
      parseInt(presentation.j1PresentationQualityandDeliveryStyle || 0)
    ];

    const judge2Data = [
      parseInt(presentation.j2BusinessAndEngineeringContext || 0),
      parseInt(presentation.j2ComplexityOfTechnicalSolutions || 0),
      parseInt(presentation.j2InterpretationOfResultsAndConclusion || 0),
      parseInt(presentation.j2BusinessValueDiscussionAndAchievement || 0),
      parseInt(presentation.j2PresentationQualityandDeliveryStyle || 0)
    ];

    const judge3Data = [
      parseInt(presentation.j3BusinessAndEngineeringContext || 0),
      parseInt(presentation.j3ComplexityOfTechnicalSolutions || 0),
      parseInt(presentation.j3InterpretationOfResultsAndConclusion || 0),
      parseInt(presentation.j3BusinessValueDiscussionAndAchievement || 0),
      parseInt(presentation.j3PresentationQualityandDeliveryStyle || 0)
    ];

    return {
      labels: categories,
      datasets: [
        {
          label: presentation.j1Name || 'Judge 1',
          data: judge1Data,
          backgroundColor: 'rgba(255, 99, 132, 0.8)',
          borderColor: 'rgba(255, 99, 132, 1)',
          borderWidth: 1,
          borderRadius: 5,
          barPercentage: 0.6,
          categoryPercentage: 0.7,
        },
        {
          label: presentation.j2Name || 'Judge 2',
          data: judge2Data,
          backgroundColor: 'rgba(54, 162, 235, 0.8)',
          borderColor: 'rgba(54, 162, 235, 1)',
          borderWidth: 1,
          borderRadius: 5,
          barPercentage: 0.6,
          categoryPercentage: 0.7,
        },
        {
          label: presentation.j3Name || 'Judge 3',
          data: judge3Data,
          backgroundColor: 'rgba(75, 192, 192, 0.8)',
          borderColor: 'rgba(75, 192, 192, 1)',
          borderWidth: 1,
          borderRadius: 5,
          barPercentage: 0.6,
          categoryPercentage: 0.7,
        },
      ],
    };
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            size: 14,
            weight: 'bold'
          },
          padding: 20
        }
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        titleFont: {
          size: 14
        },
        bodyFont: {
          size: 14
        },
        padding: 10,
        boxPadding: 5
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        max: 10,
        title: {
          display: true,
          text: 'Score',
          font: {
            size: 14,
            weight: 'bold'
          },
          padding: { top: 10, bottom: 10 }
        },
        ticks: {
          font: {
            size: 12
          },
          stepSize: 1
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.1)'
        }
      },
      x: {
        title: {
          display: true,
          text: 'Evaluation Categories',
          font: {
            size: 14,
            weight: 'bold'
          },
          padding: { top: 10, bottom: 10 }
        },
        ticks: {
          font: {
            size: 12,
            weight: 'bold'
          }
        },
        grid: {
          display: false
        }
      }
    },
    maintainAspectRatio: false,
    animation: {
      duration: 2000,
      easing: 'easeOutQuart'
    }
  };

  const [loadingWinners, setLoadingWinners] = useState(false);

  const handleTrackChange = async (e) => {
    const track = e.target.value;
    setSelectedTrack(track);
    setLoadingWinners(true);

    try {
      // fetch winners list for the selected track (API call)
      await fetchTop3(track);
    } finally {
      setLoadingWinners(false);
    }
  };

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#faf9f6' }}>
        <AppBar position="sticky" sx={{ background: "linear-gradient(to right, #1976d2, #42a5f5)" }}>
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Super Admin Dashboard
            </Typography>
            <Button
              variant="outlined"
              color="inherit"
              onClick={() => setOpenLogoutDialog(true)}
              startIcon={<LogoutIcon />}
              sx={{
                borderRadius: 50,
                textTransform: "none",
                "&:hover": { backgroundColor: "rgba(255,255,255,0.2)" },
              }}
            >
              Logout
            </Button>
          </Toolbar>
        </AppBar>

        <Box sx={{ p: 3, flex: 1 }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            sx={{
              px: 2,
              '& .MuiTab-root': {
                fontWeight: 600,
                minWidth: 'auto',
                mr: { xs: 1, sm: 2, md: 3 },
              },
            }}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
          >
            <Tab label="Admin" />
            <Tab label="Judges" />
            <Tab label="Winners" />
            <Tab label="Participants" />
          </Tabs>

          <Box sx={{ p: 4 }}>
            {/* Admins */}
            {activeTab === 0 && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 3,
                  }}
                >
                  <Typography sx={{ fontSize: 20, fontWeight: 600 }}>
                    Admins
                  </Typography>
                  <Button
                    variant="outlined"
                    onClick={() => setOpenAdminDialog(true)}
                    sx={{
                      borderRadius: 20,
                      fontWeight: 600,
                      border: '1px solid #3db4e9'
                    }}
                  >
                    Add Admin
                  </Button>
                </Box>

                {loading.admins ? (
                  <CircularProgress />
                ) : admins.length > 0 ? (
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                      gap: 2,
                    }}
                  >
                    {admins.map((admin) => (
                      <Card
                        key={admin.id}
                        sx={{
                          borderRadius: 2,
                          boxShadow: 3,
                          "&:hover": { boxShadow: 6 },
                          minHeight: 120,
                          display: 'flex',
                          alignItems: 'center',
                          position: "relative",
                        }}
                      >
                        {/* 3 dots menu button */}
                        <IconButton
                          size="small"
                          sx={{ position: "absolute", top: 4, right: 4 }}
                          onClick={(e) => handleMenuOpen(e, admin)}
                        >
                          <MoreVertIcon fontSize="small" />
                        </IconButton>

                        <CardContent>
                          <Typography variant="body2" sx={{ mt: 2.5, fontWeight: 600 }}>
                            Name : <span style={{ fontWeight: 500 }}>{admin.userName}</span>
                          </Typography>
                          <Typography variant="body2" sx={{ mt: 1, fontWeight: 600 }}>
                            Email : <span style={{ fontWeight: 500 }}>{admin.userEmail}</span>
                          </Typography>
                          <Typography variant="body2" sx={{ mt: 1, fontWeight: 600 }}>
                            Track : <span style={{ fontWeight: 500 }}>{getTrackName(admin.userTrack)}</span>
                          </Typography>
                        </CardContent>
                      </Card>
                    ))}
                    {/* Menu for delete */}
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem
                        onClick={() => { setOpenDeleteDialog(true) }}
                        sx={{ color: "black", fontWeight: 600 }}
                      >
                        Delete
                      </MenuItem>
                    </Menu>
                  </Box>
                ) : (
                  <Typography sx={{ fontWeight: 600 }}>No admins found</Typography>
                )}
              </>
            )}

            {/* Judges */}
            {activeTab === 1 && (
              <>
                <Typography variant="h5" sx={{ fontSize: 20, fontWeight: 600, mb: 2 }}>
                  Judges
                </Typography>

                {loading.judges ? (
                  <CircularProgress />
                ) : judges.length > 0 ? (
                  Object.entries(
                    judges.reduce((acc, judge) => {
                      if (!acc[judge.userTrack]) acc[judge.userTrack] = [];
                      acc[judge.userTrack].push(judge);
                      return acc;
                    }, {})
                  ).map(([track, trackJudges]) => {
                    const trackAdmin = admins.find(
                      (admin) => String(admin.userTrack) === String(track)
                    );

                    return (
                      <Card
                        key={track}
                        sx={{
                          mb: 3,
                          boxShadow: 1,
                          borderRadius: 6,
                          overflow: "hidden",
                        }}
                      >
                        <CardContent>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              fontSize: "1.3rem",
                              color: "#333",
                              background: "linear-gradient(45deg, #a8edea, #fed6e3)",
                              px: 2,
                              py: 1,
                              borderRadius: 3,
                              mb: 2,
                            }}
                          >
                            Track - {getTrackName(track)} -
                            {trackAdmin && (
                              <span style={{ fontWeight: 600, marginLeft: 12, fontSize: "1.3rem" }}>
                                {trackAdmin.userName}
                              </span>
                            )}
                          </Typography>

                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                              gap: 2,
                            }}
                          >
                            {trackJudges.map((judge) => (
                              <Card
                                key={judge.id}
                                sx={{
                                  borderRadius: 3,
                                  boxShadow: 3,
                                  // "&:hover": { boxShadow: 2, transform: "scale(1.02)" },
                                  transition: "all 0.2s ease-in-out",
                                }}
                              >
                                <CardContent>
                                  <Typography variant="body2" sx={{ mt: 1, fontWeight: 600 }}>
                                    Name : <span style={{ fontWeight: 500 }}>{judge.userName}</span>
                                  </Typography>
                                  <Typography variant="body2" sx={{ mt: 1, fontWeight: 600 }}>
                                    Email : <span style={{ fontWeight: 500 }}>{judge.userEmail}</span>
                                  </Typography>
                                </CardContent>
                              </Card>
                            ))}
                          </Box>
                        </CardContent>
                      </Card>
                    );
                  })
                ) : (
                  <Typography sx={{ fontWeight: 600 }}>No judges found</Typography>
                )}
              </>
            )}

            {/* Winners */}
            {activeTab === 2 && (
              <>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
                  <Typography variant="h5" sx={{ fontSize: 20, fontWeight: 600 }}>
                    Winners
                  </Typography>

                  {/* Tracks dropdown */}
                  <FormControl size="small" sx={{ minWidth: 150 }}>
                    <Select
                      value={selectedTrack}
                      onChange={handleTrackChange}
                      sx={{
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        minWidth: 150,
                        fontWeight: '600',
                        fontSize: '0.95rem',
                      }}
                    >
                      {[1, 2, 3, 4, 5, 6].map((track) => (
                        <MenuItem
                          key={track}
                          value={track}
                          sx={{ fontSize: '0.95rem', fontWeight: 600 }}
                        >
                          Track - {getTrackName(track)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                {loadingWinners ? (
                  <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 250 }}>
                    <CircularProgress size={45} thickness={4} />
                  </Box>
                ) : (
                  <>
                    <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 3, mb: 4 }}>
                      <Table>
                        <TableHead>
                          <TableRow sx={{ background: "linear-gradient(45deg, #a8edea, #fed6e3)" }}>
                            <TableCell sx={{ fontSize: 16, fontWeight: 600 }}>Rank</TableCell>
                            <TableCell sx={{ fontSize: 16, fontWeight: 600 }}>Name</TableCell>
                            <TableCell sx={{ fontSize: 16, fontWeight: 600 }}>Title</TableCell>
                            <TableCell sx={{ fontSize: 16, fontWeight: 600 }} align="center">Day</TableCell>
                            <TableCell sx={{ fontSize: 16, fontWeight: 600 }} align="center">Total Score</TableCell>
                            <TableCell sx={{ fontSize: 16, fontWeight: 600 }} align="center">Certificate</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {top3List.length > 0 ? (
                            top3List.map((item) => (
                              <TableRow key={item.presentation.id}>
                                <TableCell>
                                  <Box
                                    sx={{
                                      backgroundColor:
                                        item.rank === 1
                                          ? "#388e3c"
                                          : item.rank === 2
                                            ? "#9c27b0"
                                            : "#2196f3",
                                      color: "#fff",
                                      px: 1.5,
                                      py: 0.5,
                                      borderRadius: "16px",
                                      fontWeight: "bold",
                                      display: "inline-block",
                                      textAlign: "center",
                                      minWidth: "32px",
                                    }}
                                  >
                                    #{item.rank}
                                  </Box>
                                </TableCell>
                                <TableCell sx={{ fontSize: 18, fontWeight: 500 }}>
                                  {item.presentation.authorName}
                                </TableCell>
                                <TableCell sx={{ fontSize: 18, fontWeight: 500 }}>
                                  {item.presentation.title}
                                </TableCell>
                                <TableCell sx={{ fontSize: 18, fontWeight: 500 }} align="center">
                                  {item.presentation.day}
                                </TableCell>
                                <TableCell sx={{ fontSize: 18, fontWeight: 500 }} align="center">
                                  {item.finalScore}
                                </TableCell>
                                <TableCell align="center">
                                  <Button
                                    variant="contained"
                                    onClick={() => generateCertificate(item)}
                                    sx={{
                                      backgroundColor: '#4caf50',
                                      '&:hover': { backgroundColor: '#388e3c' },
                                      fontWeight: 600,
                                      borderRadius: 2,
                                      textTransform: 'none',
                                    }}
                                  >
                                    Certificate
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={6} align="center" sx={{ fontSize: 15, fontWeight: 600, color: 'gray' }}>
                                No winners found
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    {top3List.length > 0 && (
                      <>
                        <Typography
                          variant="h5"
                          sx={{ mt: 4, mb: 3, fontWeight: 600, textAlign: 'center', color: '#2c3e50' }}
                        >
                          Category-wise Scores by Judges
                        </Typography>

                        <Grid container fullWidth spacing={3} sx={{ mb: 4 }}>
                          {top3List.map((item) => (
                            <Grid item xs={12} key={item.presentation.id}>
                              <Box
                                sx={{
                                  mb: 3,
                                  p: 2.5,
                                  width: '100%',
                                  maxWidth: '850px',
                                  mx: 'auto',
                                  backgroundColor: '#fafafa',
                                  borderRadius: 2,
                                  border: '1px solid #eeeeee'
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                                  <Box
                                    sx={{
                                      backgroundColor: '#e0e0e0',
                                      color: '#2d3436',
                                      width: 42,
                                      height: 42,
                                      borderRadius: "50%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontWeight: "bold",
                                      fontSize: 18,
                                      mr: 3
                                    }}
                                  >
                                    #{item.rank}
                                  </Box>
                                  <Box>
                                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 0.5 }}>
                                      {item.presentation.authorName}
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: '#757575' }}>
                                      {item.presentation.title}
                                    </Typography>
                                  </Box>
                                </Box>

                                <Box
                                  sx={{
                                    display: 'flex',
                                    gap: 2,
                                    mt: 2,
                                    pt: 2,
                                    borderTop: '1px solid #eeeeee'
                                  }}
                                >
                                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <ScheduleIcon sx={{ mr: 1, color: '#616161' }} />
                                    <Typography variant="body2">
                                      Day {item.presentation.day}
                                    </Typography>
                                  </Box>
                                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Typography variant="body2" sx={{ fontWeight: 'medium' }}>
                                      Final Score:
                                    </Typography>
                                    <Typography variant="body1" sx={{ fontWeight: 'bold', ml: 1 }}>
                                      {item.finalScore}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Box>

                              <Box
                                sx={{
                                  height: 400,
                                  width: '100%',
                                  p: 1,
                                  backgroundColor: 'white',
                                  borderRadius: 2,
                                  boxShadow: 3
                                }}
                              >
                                <Bar
                                  data={prepareChartData(item.presentation)}
                                  options={chartOptions}
                                />
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      </>
                    )}
                  </>
                )}
              </>
            )}

            {activeTab === 3 && <CertificateGenerator />}
          </Box>
        </Box>

        {/* Add Admin Dialog */}
        <Dialog open={openAdminDialog} onClose={handleAdminDialogClose} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ fontSize: 18, fontWeight: 600 }}>Add New Admin</DialogTitle>
          <form onSubmit={handleAddAdmin}>
            <DialogContent>
              {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
              {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <TextField
                  label={
                    <>
                      <span style={{ fontSize: '14px', fontWeight: 600 }}>Admin Name</span>
                      <span style={{ color: 'red' }}> *</span>
                    </>
                  }
                  type="text"
                  fullWidth
                  name="userName"
                  value={adminData.userName}
                  onChange={handleChange}
                  required
                  InputLabelProps={{
                    sx: {
                      '& .MuiFormLabel-asterisk': { display: 'none' },
                    },
                  }}
                />
                <TextField
                  label={
                    <>
                      <span style={{ fontSize: '14px', fontWeight: 600 }}>Email</span>
                      <span style={{ color: 'red' }}> *</span>
                    </>
                  }
                  type="email"
                  fullWidth
                  name="userEmail"
                  value={adminData.userEmail}
                  onChange={handleChange}
                  required
                  InputLabelProps={{
                    sx: {
                      '& .MuiFormLabel-asterisk': { display: 'none' },
                    },
                  }}
                />
                <TextField
                  label={
                    <>
                      <span style={{ fontSize: '14px', fontWeight: 600 }}>Password</span>
                      <span style={{ color: 'red' }}> *</span>
                    </>
                  }
                  type={showAdminPassword ? 'text' : 'password'}
                  fullWidth
                  name="userPassword"
                  value={adminData.userPassword}
                  onChange={handleChange}
                  required
                  InputLabelProps={{
                    sx: {
                      '& .MuiFormLabel-asterisk': { display: 'none' },
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowAdminPassword(!showAdminPassword)}
                          edge="end"
                        >
                          {showAdminPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  label={
                    <>
                      <span style={{ fontSize: '14px', fontWeight: 600 }}>Track Number</span>
                      <span style={{ color: 'red' }}> *</span>
                    </>
                  }
                  type="number"
                  fullWidth
                  name="userTrack"
                  value={adminData.userTrack}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "" || (Number(value) >= 1 && Number(value) <= 6)) {
                      handleChange(e);
                    }
                  }}
                  required
                  inputProps={{ min: 1, max: 6 }}
                  InputLabelProps={{
                    sx: {
                      '& .MuiFormLabel-asterisk': { display: 'none' },
                    },
                  }}
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleAdminDialogClose} sx={{ fontWeight: 600 }}>Cancel</Button>
              <Button type="submit" variant="outlined" sx={{ fontWeight: 600, borderRadius: 16 }} >
                Add Admin
              </Button>
            </DialogActions>
          </form>
        </Dialog>

        <Dialog open={openLogoutDialog} onClose={() => setOpenLogoutDialog(false)} maxWidth="xs" fullWidth>
          <DialogContent>
            <Typography sx={{ fontWeight: 600 }}>Are you sure you want to logout ?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenLogoutDialog(false)} sx={{ fontWeight: 600 }}>
              Cancel
            </Button>
            <Button
              onClick={handleLogoutConfirm}
              color="error"
              variant="outlined"
              sx={{ fontWeight: 600, borderRadius: 16 }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)} maxWidth="xs" fullWidth>
          <DialogContent>
            <Typography sx={{ fontWeight: 600 }}>
              Are you sure you want to delete this admin ?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => setOpenDeleteDialog(false)}
              sx={{ fontWeight: 600 }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleDeleteAdmin}
              color="error"
              variant="outlined"
              sx={{ fontWeight: 600, borderRadius: 16 }}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default SuperAdmin;